import AbstractShape, {Dimensions} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import makerjs, { IChain, IModel } from "makerjs";
import uniqBy from "lodash/uniqBy";
import take from "lodash/take";
import DimensionLine from "../Lines/DimensionLine";

export class DXF extends AbstractShape {
	constructor( model: IModel ) {
		super( 'dxf' );
		this.model = model;
	}

	createModel(): void {}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if ( ! this.model ) {
			return [];
		}

		const measure = makerjs.measure.modelExtents( this.model );
		const extremes = [[measure.low[0], measure.low[1]], [measure.high[0], measure.high[1]]];

		const verticalLines = [];
		const horizontalLines = [];
		const shapeBottom = extremes[0][1];
		const shapeLeft = extremes[0][0];

		const chains = makerjs.model.findChains( this.model ) as IChain[];
		for ( const chain of chains ) {
			const chainModel = makerjs.chain.toNewModel( chain, false );
			const chainMeasure = makerjs.measure.modelExtents( chainModel );
			const chainExtreme = [[chainMeasure.low[0], chainMeasure.low[1]], [chainMeasure.high[0], chainMeasure.high[1]]];
			verticalLines.push(new DimensionLine( [shapeLeft, chainExtreme[0][1]], [ shapeLeft, chainExtreme[1][1] ], this.renderDimensionLabel( 'height', new Length(chainExtreme[1][1] - chainExtreme[0][1]) ), [-40, 0], ratio)); // Vertical line
			horizontalLines.push(new DimensionLine( [chainExtreme[0][0], shapeBottom], [ chainExtreme[1][0], shapeBottom ], this.renderDimensionLabel( 'width', new Length(chainExtreme[1][0] - chainExtreme[0][0]) ), [0, -40], ratio )); // Horizontal line
		}

		const limitedVerticalLines = take( uniqBy( verticalLines, 'label' ), 10 );
		limitedVerticalLines.sort((a, b) => b.getLength() - a.getLength()); // We want to show the longest lines first
		limitedVerticalLines.forEach( ( line, index ) => {
			line.shiftOffset( index + 1 );
		});

		const limitedHorizontalLines = take( uniqBy( horizontalLines, 'label' ), 10 );
		limitedHorizontalLines.sort((a, b) => b.getLength() - a.getLength()); // We want to show the longest lines first
		limitedHorizontalLines.forEach( ( line, index ) => {
			line.shiftOffset( index + 1 );
		});

		return [].concat( limitedVerticalLines, limitedHorizontalLines );
	}

	getLength(): Length {
		const measure = makerjs.measure.modelExtents( this.model );
		return Length.from_mm( measure.height );
	}

	getWidth(): Length {
		const measure = makerjs.measure.modelExtents( this.model );
		return Length.from_mm( measure.width );
	}

	/**
	 * Gets the length from the passed extreme array.
	 *
	 * @param {array} extremes The extremes to get.
	 */
	getLengthFromExtreme( extremes ): Length {
		const [min, max] = extremes;
		const [min_x] = min;
		const [max_x] = max;

		return new Length( max_x - min_x );
	}

	/**
	 * Gets the width from the passed extreme array.
	 *
	 * @param {array} extremes The extremes to get.
	 */
	getWidthFromExtreme( extremes ): Length {
		const [min, max] = extremes;
		const [, min_y] = min;
		const [, max_y] = max;

		return new Length( max_y - min_y );
	}

	getDefaultDimensions(): Dimensions {
		return {};
	}

	getDefaultCutoutDimensions(): Dimensions {
		return {};
	}
}
